export var Direction;
(function (Direction) {
    Direction["Bottom"] = "bottom";
    Direction["Right"] = "right";
    Direction["Top"] = "top";
    Direction["Left"] = "left";
})(Direction || (Direction = {}));
export const calculateAbsoluteLeftPositionForMobile = ({ direction, left, portalWidth, bodyWidth, parentLeft, parentWidth }) => {
    // should return the original absolute left,
    // when the direction strategy is not top or bottom
    if (!['top', 'bottom'].includes(direction)) {
        return left;
    }
    // when the parent is so far out to the right, a horizontally centered portal would not be wide enough to reach it
    const distanceFromRight = bodyWidth - parentLeft - parentWidth;
    if (bodyWidth / 2 - distanceFromRight > portalWidth / 2) {
        return left;
    }
    // when the parent is so far out to the left, a horizontally centered portal would not be wide enough to reach it
    if (bodyWidth / 2 - parentLeft > portalWidth / 2) {
        return left;
    }
    // otherwise,
    // should recalculate the absolute left value to horizontally center the tooltip on the screen
    const unoccupiedHorizontalSpace = bodyWidth - portalWidth;
    return unoccupiedHorizontalSpace / 2;
};
// default position strategy taken from https://github.com/codastic/react-positioning-portal
// adjusted to work with preferredPosition prop
export const getTooltipPosition = (preferredPosition) => (parentRect, portalRect) => {
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;
    const body = window.document.documentElement || window.document.body;
    const horizontalCenter = (parentRect.width - portalRect.width) / 2;
    const verticalCenter = (parentRect.height - portalRect.height) / 2;
    const additionalPadding = 8;
    const positions = {
        [Direction.Bottom]: {
            position: Direction.Bottom,
            top: parentRect.top + parentRect.height + scrollY + additionalPadding,
            left: parentRect.left + scrollX + horizontalCenter,
            enoughSpace: parentRect.top +
                parentRect.height +
                portalRect.height +
                additionalPadding <
                body.clientHeight
        },
        [Direction.Top]: {
            position: Direction.Top,
            top: parentRect.top - portalRect.height + scrollY - additionalPadding,
            left: parentRect.left + scrollX + horizontalCenter,
            enoughSpace: parentRect.top - portalRect.height - additionalPadding > 0
        },
        [Direction.Left]: {
            position: Direction.Left,
            top: parentRect.top + scrollY + verticalCenter,
            left: parentRect.left + scrollX - portalRect.width - additionalPadding,
            enoughSpace: parentRect.left - portalRect.width - additionalPadding > 0
        },
        [Direction.Right]: {
            position: Direction.Right,
            top: parentRect.top + scrollY + verticalCenter,
            left: parentRect.left + scrollX + parentRect.width + additionalPadding,
            enoughSpace: parentRect.left +
                parentRect.width +
                portalRect.width +
                additionalPadding <
                body.clientWidth
        }
    };
    // Horizontal fallback preferred
    let sortedPositions = [
        positions[preferredPosition],
        positions[Direction.Bottom],
        positions[Direction.Top],
        positions[Direction.Right],
        positions[Direction.Left]
    ];
    // Vertical fallback preferred
    if (preferredPosition === Direction.Left ||
        preferredPosition === Direction.Right) {
        sortedPositions = [
            positions[preferredPosition],
            positions[Direction.Right],
            positions[Direction.Left],
            positions[Direction.Bottom],
            positions[Direction.Top]
        ];
    }
    const pickedPosition = sortedPositions.find(({ enoughSpace }) => enoughSpace) ||
        positions[preferredPosition];
    const finalTop = Math.max(Math.min(pickedPosition.top, body.clientHeight + scrollY - portalRect.height), scrollY);
    const left = Math.max(Math.min(pickedPosition.left, body.clientWidth + scrollX - portalRect.width), scrollX);
    const finalLeft = calculateAbsoluteLeftPositionForMobile({
        direction: pickedPosition.position,
        left,
        portalWidth: portalRect.width,
        bodyWidth: body.clientWidth,
        parentLeft: parentRect.left,
        parentWidth: parentRect.width
    });
    const shiftY = Math.max(Math.min(finalTop - pickedPosition.top, portalRect.height / 2 - additionalPadding * 1.5), portalRect.height / -2 + additionalPadding * 1.5);
    const shiftX = Math.max(Math.min(finalLeft - pickedPosition.left, portalRect.width / 2 - additionalPadding * 1.5), portalRect.width / -2 + additionalPadding * 1.5);
    return {
        top: finalTop,
        left: finalLeft,
        strategy: {
            position: pickedPosition.position,
            shift: (['top', 'bottom'].includes(pickedPosition.position)
                ? shiftX
                : shiftY) * -1
        }
    };
};
//# sourceMappingURL=getTooltipPosition.js.map